import { Modal } from "bootstrap";
import { waitForAlpineStore } from "../waitForAlpineStore";

export const appUpdater = {
  modal: null,
  stopNaggingKey: "sw_stop_nagging",
  installedKey: "sw_installed",

  init() {
    waitForAlpineStore("pwa").then((store) => {
      console.log(store.isInstalled);
      if (store.isInstalled) {
        const el = document.getElementById("appUpdateModal");
        if (!el) return;

        this.modal = new Modal(el);

        if (!("serviceWorker" in navigator)) return;

        navigator.serviceWorker.ready.then(() => {
          this._markInstalledIfFirstTime();
          this._listenForControllerChange();
          this._forceWaitingSWToActivate();
        });
      } else {
        return false; // this store works only when app is running in a separate window as a PWA
      }
    });
  },

  /* -------------------------------------------------- */

  _markInstalledIfFirstTime() {
    if (!localStorage.getItem(this.installedKey)) {
      // First-ever install → DO NOT show modal
      localStorage.setItem(this.installedKey, "1");
      localStorage.removeItem(this.stopNaggingKey); // clear any stale nag flag
    }
  },

  _listenForControllerChange() {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this._shouldNag()) {
        this.showUpdateAvailability();
      }
    });
  },

  _forceWaitingSWToActivate() {
    navigator.serviceWorker.getRegistration().then((reg) => {
      if (reg?.waiting) {
        reg.waiting.postMessage({ type: "SKIP_WAITING" });
        localStorage.removeItem(this.stopNaggingKey); // silent update applied — reset nag flag
      }
    });
  },

  _shouldNag() {
    // No SW before → first install → suppress
    if (!localStorage.getItem(this.installedKey)) return false;

    // User said “don’t nag”
    if (localStorage.getItem(this.stopNaggingKey) === "1") return false;

    return true;
  },

  /* -------------------------------------------------- */

  showUpdateAvailability() {
    this.modal?.show();
  },

  updateApp() {
    window.location.reload();
    localStorage.removeItem(this.stopNaggingKey);
  },

  stopNagging() {
    localStorage.setItem(this.stopNaggingKey, "1");
    this.modal?.hide();
  },
};
